/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "variant_default": "flex flex-col items-start gap-y-1",
  "label_variant_default": "text-al-body-sm",
  "label_variant_floating": "absolute top-3 left-2.5 duration-300 transform scale-75 z-10 origin-[0] -translate-y-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-1 text-al-body-sm",
  "label_status_default": "text-al-gray-800",
  "label_status_error": "text-al-gray-800",
  "field_status_default": "placeholder:text-al-gray-500 hover:placeholder:text-black focus:placeholder:text-black border-al-gray-600 hover:border-black focus:border-al-petroleum-600 focus:outline focus:outline-2 focus:outline-offset-0 focus:outline-al-petroleum-100",
  "field_status_error": "focus:outline focus:outline-4 focus:outline-offset-0 bg-error-99 placeholder:text-al-gray-500 hover:placeholder:text-black focus:placeholder:text-black border border-al-error-500 focus:outline-al-error-100",
  "field_variant_default": "block w-full resize-none box-border p-2.5 leading-6.5 border border-solid rounded appearance-none text-al-body-lg",
  "field_variant_floating": "block w-full resize-none box-border p-2.5 leading-6.5 border border-solid rounded appearance-none focus:ring-0 peer placeholder:!text-transparent text-al-body-lg pt-5",
  "field_size_default": "h-35 w-55",
  "field_group_variant_default": "flex flex-col-reverse gap-y-1",
  "field_group_variant_floating": "relative",
  "caption_variant_default": "text-al-body-sm",
  "caption_status_error": "text-al-error-500",
  "caption_group_size_default": "gap-2",
  "caption_group_variant_default": "flex items-center",
  "caption_group_status_error": "text-black",
  "caption_status_default": "text-al-gray-800"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "TextArea");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;